import styled from "styled-components";
import * as h from "../../../ui/_themes/helpers";

export const StyledSubTitle = styled.div`
  color: ${h.getColor("settingsWindowSubTitle", "settingsWindow.subtitle")};
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 0.7em;
  margin-bottom: 0.8em;
  font-weight: 700;
  user-select: none;
`;
